export interface Video {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  rating: number;
  description: string;
  year: number;
  duration: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  views: string;
}

export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门国产电视剧在线观看，每日更新最新剧集' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '高清国产电影免费在线观看，涵盖动作、喜剧、爱情等多种类型' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '国产综艺节目在线观看，搞笑、音乐、真人秀应有尽有' },
  { slug: 'duanpian', name: '短片', icon: 'ri-video-line', description: '精选国产短视频、微电影在线观看，创意无限' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '国产动漫在线观看，热血、奇幻、治愈全都有' },
];

export const videos: Video[] = [
  {
    id: 'v1',
    title: '长安十二时辰',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20palace%20scene%20with%20lanterns%20and%20warriors%20in%20traditional%20armor%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20epic%20historical%20drama%20atmosphere%2C%20high%20detail%20photography%20style%2C%20moody%20and%20atmospheric&width=800&height=450&seq=v1-changan&orientation=landscape',
    rating: 8.3,
    description: '以唐朝长安城为背景的悬疑古装剧，讲述死囚张小敬在十二时辰内侦破惊天阴谋的故事。',
    year: 2019,
    duration: '45分钟/集',
    tags: ['古装', '悬疑', '历史'],
    isHot: true,
    isNew: false,
    views: '3.2亿',
  },
  {
    id: 'v2',
    title: '漫长的季节',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20town%20in%20autumn%20with%20falling%20leaves%2C%20old%20factory%20buildings%2C%20nostalgic%201990s%20Chinese%20atmosphere%2C%20warm%20amber%20and%20golden%20tones%2C%20cinematic%20drama%20style%2C%20poetic%20and%20melancholic%20mood&width=800&height=450&seq=v2-season&orientation=landscape',
    rating: 9.4,
    description: '一宗尘封多年的碎尸案将几个家庭的命运紧紧交织，揭开东北小城二十年的悲欢离合。',
    year: 2023,
    duration: '60分钟/集',
    tags: ['悬疑', '犯罪', '家庭'],
    isHot: true,
    isNew: true,
    views: '5.8亿',
  },
  {
    id: 'v3',
    title: '流浪地球2',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20with%20Earth%20in%20background%2C%20sci-fi%20Chinese%20movie%20scene%2C%20massive%20engines%20and%20technology%2C%20dramatic%20blue%20and%20orange%20lighting%2C%20epic%20cinematic%20scale%2C%20high%20contrast%20photography&width=800&height=450&seq=v3-wandering&orientation=landscape',
    rating: 8.3,
    description: '太阳即将毁灭，人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅。',
    year: 2023,
    duration: '173分钟',
    tags: ['科幻', '灾难', '冒险'],
    isHot: true,
    isNew: true,
    views: '8.5亿',
  },
  {
    id: 'v4',
    title: '狂飙',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20police%20officer%20in%20rainy%20urban%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20crime%20drama%20atmosphere%2C%20dark%20moody%20tones%20with%20red%20and%20blue%20accents%2C%20cinematic%20noir%20style%2C%20tense%20thriller%20vibe&width=800&height=450&seq=v4-kb&orientation=landscape',
    rating: 8.5,
    description: '一线刑警安欣与黑恶势力展开长达二十年的生死较量，揭露政法队伍内部的腐败问题。',
    year: 2023,
    duration: '45分钟/集',
    tags: ['刑侦', '扫黑', '剧情'],
    isHot: true,
    isNew: false,
    views: '12.6亿',
  },
  {
    id: 'v5',
    title: '你好，李焕英',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%201980s%20factory%20town%20with%20warm%20nostalgic%20lighting%2C%20mother%20and%20daughter%20silhouette%20in%20golden%20sunset%2C%20vintage%20Chinese%20clothing%2C%20emotional%20family%20drama%20atmosphere%2C%20soft%20warm%20tones%2C%20heartwarming%20cinematic%20style&width=800&height=450&seq=v5-hly&orientation=landscape',
    rating: 7.8,
    description: '2001年刚考上大学的贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇。',
    year: 2021,
    duration: '128分钟',
    tags: ['喜剧', '亲情', '穿越'],
    isHot: true,
    isNew: false,
    views: '9.2亿',
  },
  {
    id: 'v6',
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20outdoor%20scene%20with%20group%20of%20celebrities%20running%20in%20nature%20park%2C%20bright%20sunny%20day%2C%20green%20forest%20and%20lake%20background%2C%20energetic%20vibrant%20atmosphere%2C%20colorful%20sportswear%2C%20fun%20and%20dynamic%20photography&width=800&height=450&seq=v6-running&orientation=landscape',
    rating: 7.2,
    duration: '90分钟/期',
    description: '兄弟团成员携手飞行嘉宾，在美丽的自然生态中展开趣味挑战，传递环保理念。',
    year: 2024,
    tags: ['户外', '竞技', '真人秀'],
    isHot: true,
    isNew: true,
    views: '4.1亿',
  },
  {
    id: 'v7',
    title: '封神第一部',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20battle%20scene%20with%20warriors%20in%20bronze%20armor%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20fantasy%20elements%2C%20grand%20palace%20in%20background%2C%20golden%20and%20crimson%20tones%2C%20epic%20cinematic%20style%2C%20highly%20detailed&width=800&height=450&seq=v7-fengshen&orientation=landscape',
    rating: 7.8,
    description: '商王殷寿暴虐无道，姬发觉醒踏上封神之路，仙界与人间的命运由此改写。',
    year: 2023,
    duration: '148分钟',
    tags: ['奇幻', '史诗', '神话'],
    isHot: true,
    isNew: false,
    views: '6.8亿',
  },
  {
    id: 'v8',
    title: '三体',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20scene%20with%20three%20suns%20in%20alien%20sky%2C%20scientific%20research%20facility%20in%20foreground%2C%20Chinese%20sci-fi%20drama%20atmosphere%2C%20deep%20space%20background%2C%20cool%20blue%20and%20purple%20tones%20replaced%20with%20teal%20and%20amber%2C%20thought-provoking%20cinematic%20style&width=800&height=450&seq=v8-threebody&orientation=landscape',
    rating: 8.7,
    description: '纳米科学家汪淼被卷入神秘事件，揭开地球文明与三体文明之间的宇宙级博弈。',
    year: 2023,
    duration: '45分钟/集',
    tags: ['科幻', '悬疑', '剧情'],
    isHot: true,
    isNew: false,
    views: '7.3亿',
  },
  {
    id: 'v9',
    title: '孤注一掷',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Southeast%20Asian%20casino%20interior%20with%20dim%20neon%20lighting%2C%20tense%20atmosphere%2C%20computer%20screens%20and%20gambling%20tables%2C%20Chinese%20crime%20thriller%20style%2C%20dark%20moody%20red%20and%20green%20accents%2C%20suspenseful%20cinematic%20photography%2C%20gritty%20realistic&width=800&height=450&seq=v9-no-more-bets&orientation=landscape',
    rating: 7.0,
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外卷入境外诈骗工厂的惊天陷阱。',
    year: 2023,
    duration: '130分钟',
    tags: ['犯罪', '剧情', '反诈'],
    isHot: true,
    isNew: true,
    views: '10.2亿',
  },
  {
    id: 'v10',
    title: '山海情',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Rural%20northwest%20China%20landscape%20with%20loess%20plateau%20and%20small%20village%2C%20golden%20hour%20sunlight%2C%20Chinese%20farmers%20working%20in%20fields%2C%20humble%20earthy%20tones%2C%20heartfelt%20documentary%20style%2C%20warm%20natural%20lighting%2C%20humanistic%20photography&width=800&height=450&seq=v10-mountain&orientation=landscape',
    rating: 9.2,
    description: '西海固人民在国家扶贫政策引导下，将风沙走石的干沙滩建设成寸土寸金的金沙滩。',
    year: 2021,
    duration: '45分钟/集',
    tags: ['扶贫', '剧情', '励志'],
    isHot: false,
    isNew: false,
    views: '4.5亿',
  },
  {
    id: 'v11',
    title: '王牌对王牌',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20TV%20studio%20game%20show%20set%20with%20bright%20stage%20lights%2C%20two%20teams%20of%20celebrities%20facing%20off%2C%20energetic%20vibrant%20atmosphere%2C%20colorful%20costumes%2C%20fun%20competitive%20spirit%2C%20dynamic%20entertainment%20photography&width=800&height=450&seq=v11-ace&orientation=landscape',
    rating: 7.5,
    description: '两大王牌团队正面PK，经典IP重现舞台，情怀与欢笑交织的综艺盛宴。',
    year: 2024,
    duration: '100分钟/期',
    tags: ['室内', '竞技', '怀旧'],
    isHot: true,
    isNew: true,
    views: '5.6亿',
  },
  {
    id: 'v12',
    title: '大山的女儿',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20standing%20in%20mountain%20village%20among%20locals%2C%20terraced%20fields%20and%20misty%20mountains%20in%20background%2C%20golden%20sunlight%2C%20inspiring%20atmosphere%2C%20green%20lush%20landscape%2C%20humanistic%20documentary%20style%2C%20warm%20earth%20tones&width=800&height=450&seq=v12-mountain-girl&orientation=landscape',
    rating: 9.3,
    description: '黄文秀从名校毕业后回到家乡，带领百坭村群众在脱贫攻坚一线倾情投入、奉献自我。',
    year: 2022,
    duration: '45分钟/集',
    tags: ['扶贫', '传记', '正能量'],
    isHot: false,
    isNew: false,
    views: '2.8亿',
  },
  {
    id: 'v13',
    title: '深海',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20underwater%20fantasy%20world%20with%20colorful%20coral%20reefs%20and%20magical%20sea%20creatures%2C%20young%20girl%20character%20diving%2C%20vibrant%20ink-wash%20painting%20style%2C%20dreamy%20atmosphere%2C%20purple%20and%20teal%20gradients%20replaced%20with%20coral%20and%20aquamarine%2C%20artistic%20animation&width=800&height=450&seq=v13-deepsea&orientation=landscape',
    rating: 7.3,
    description: '少女参宿误入梦幻深海世界，在与南河的冒险旅程中寻找回家的路和内心的光。',
    year: 2023,
    duration: '112分钟',
    tags: ['奇幻', '冒险', '治愈'],
    isHot: true,
    isNew: true,
    views: '3.1亿',
  },
  {
    id: 'v14',
    title: '去有风的地方',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Yunnan%20ancient%20town%20with%20traditional%20Chinese%20architecture%2C%20wind%20blowing%20through%20rice%20fields%2C%20young%20couple%20walking%20on%20stone%20path%2C%20sunny%20peaceful%20atmosphere%2C%20green%20mountains%20and%20blue%20sky%2C%20romantic%20drama%20style%2C%20soft%20natural%20lighting&width=800&height=450&seq=v14-wind&orientation=landscape',
    rating: 8.1,
    description: '辞职后的许红豆来到大理云苗村，在这里遇见了回乡创业的谢之遥，开启了治愈之旅。',
    year: 2023,
    duration: '45分钟/集',
    tags: ['爱情', '治愈', '田园'],
    isHot: true,
    isNew: false,
    views: '6.2亿',
  },
  {
    id: 'v15',
    title: '满江红',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20at%20dusk%20with%20red%20lanterns%20hanging%2C%20soldiers%20in%20Song%20Dynasty%20armor%20patrolling%2C%20narrow%20alleyways%20of%20traditional%20architecture%2C%20suspenseful%20atmosphere%2C%20deep%20red%20and%20dark%20tones%2C%20historical%20thriller%20cinematic%20style&width=800&height=450&seq=v15-mjh&orientation=landscape',
    rating: 7.4,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈，一个小兵却揭开了一场惊天阴谋。',
    year: 2023,
    duration: '159分钟',
    tags: ['悬疑', '喜剧', '历史'],
    isHot: true,
    isNew: false,
    views: '11.3亿',
  },
  {
    id: 'v16',
    title: '庆余年第二季',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?width=800&height=450&seq=v16-qyn&orientation=landscape&query=Chinese%20fantasy%20drama%20palace%20scene%20with%20young%20man%20in%20elegant%20traditional%20robe%2C%20grand%20imperial%20hall%20with%20golden%20decorations%2C%20court%20officials%20gathered%2C%20warm%20luxurious%20lighting%2C%20intrigue%20atmosphere%2C%00epic%20historical%20fantasy%20style',
    rating: 7.9,
    description: '范闲从北齐归来，面对二皇子的威胁与朝堂风云变幻，在权谋漩涡中守护所爱之人。',
    year: 2024,
    duration: '45分钟/集',
    tags: ['古装', '权谋', '爱情'],
    isHot: true,
    isNew: true,
    views: '8.9亿',
  },
  {
    id: 'v17',
    title: '极限挑战',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20celebrities%20doing%20fun%20outdoor%20challenges%20in%20modern%20city%2C%20urban%20street%20setting%2C%20bright%20sunny%20day%2C%20colorful%20casual%20clothing%2C%20playful%20energetic%20atmosphere%2C%20team%20game%20vibe%2C%20dynamic%20action%20photography&width=800&height=450&seq=v17-extreme&orientation=landscape',
    rating: 7.8,
    description: '极限男人帮再次出发，在城市街头展开智慧与体力的双重挑战，笑料不断精彩纷呈。',
    year: 2024,
    duration: '95分钟/期',
    tags: ['户外', '竞技', '搞笑'],
    isHot: false,
    isNew: true,
    views: '4.8亿',
  },
  {
    id: 'v18',
    title: '宇宙探索编辑部',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Eccentric%20Chinese%20scientist%20in%20cluttered%20office%20filled%20with%20telescopes%20and%20star%20maps%2C%20odd%20sci-fi%20paraphernalia%2C%20warm%20dusty%20lighting%2C%20quirky%20indie%20film%20atmosphere%2C%20mockumentary%20style%2C%20nostalgic%201990s%20Chinese%20aesthetic&width=800&height=450&seq=v18-cosmic&orientation=landscape',
    rating: 8.0,
    description: '落魄的科幻杂志主编唐志军，执着地寻找外星文明，一场荒诞又浪漫的公路之旅就此展开。',
    year: 2023,
    duration: '118分钟',
    tags: ['喜剧', '科幻', '文艺'],
    isHot: false,
    isNew: true,
    views: '1.5亿',
  },
  {
    id: 'v19',
    title: '长安三万里',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20Chinese%20animation%20scene%20with%20poet%20on%20horseback%20riding%20through%20ancient%20city%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20golden%20sunset%20over%20pagodas%20and%20mountains%2C%20poetic%20atmosphere%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20artistic%20masterpiece&width=800&height=450&seq=v19-cs3wl&orientation=landscape',
    rating: 8.3,
    description: '安史之乱后，高适回忆起自己与李白跨越数十年的深厚情谊和那个群星闪耀的大唐时代。',
    year: 2023,
    duration: '168分钟',
    tags: ['历史', '诗歌', '友情'],
    isHot: true,
    isNew: false,
    views: '5.4亿',
  },
  {
    id: 'v20',
    title: '微光城市',
    category: 'duanpian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20short%20film%20scene%20in%20modern%20city%20at%20dusk%2C%20young%20couple%20on%20rooftop%20overlooking%20skyline%2C%20city%20lights%20beginning%20to%20glow%2C%20intimate%20atmosphere%2C%20soft%20twilight%20colors%2C%20independent%20film%20aesthetic%2C%20romantic%20minimalist%20style&width=800&height=450&seq=v20-twilight&orientation=landscape',
    rating: 8.5,
    description: '夜幕降临的城市，两个陌生人的偶然相遇，在微光中展开一段温暖治愈的都市故事。',
    year: 2024,
    duration: '25分钟',
    tags: ['爱情', '都市', '治愈'],
    isHot: false,
    isNew: true,
    views: '0.8亿',
  },
  {
    id: 'v21',
    title: '漫长的告白',
    category: 'duanpian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20short%20film%20scene%20on%20train%20platform%20at%20sunset%2C%20young%20man%20and%20woman%20standing%20apart%2C%20golden%20hour%20light%2C%20nostalgic%20melancholic%20atmosphere%2C%20Japanese%20anime%20inspired%20cinematography%20but%20Chinese%20setting%2C%20poetic%20visual%20style&width=800&height=450&seq=v21-confession&orientation=landscape',
    rating: 8.7,
    description: '一个即将远行的少年，用一整个夏天写下对暗恋女孩的告白，那是青春最漫长的等待。',
    year: 2024,
    duration: '18分钟',
    tags: ['青春', '爱情', '文艺'],
    isHot: false,
    isNew: true,
    views: '1.2亿',
  },
  {
    id: 'v22',
    title: '哪吒之魔童降世',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20mythological%20boy%20character%20with%20flaming%20wheels%20and%20red%20sash%20flying%20in%20stormy%20sky%2C%20epic%20fantasy%20battle%2C%20traditional%20Chinese%20elements%2C%20dynamic%20action%2C%20vibrant%20red%20and%20gold%20colors%2C%20powerful%20animation%20style&width=800&height=450&seq=v22-nezha&orientation=landscape',
    rating: 8.4,
    description: '天地灵气孕育出混元珠，被炼化为魔丸和灵珠。哪吒虽生而为魔，却偏要逆天改命。',
    year: 2019,
    duration: '110分钟',
    tags: ['神话', '动作', '励志'],
    isHot: true,
    isNew: false,
    views: '9.8亿',
  },
  {
    id: 'v23',
    title: '白蛇：缘起',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20fantasy%20scene%20with%20beautiful%20woman%20in%20white%20traditional%20dress%20in%20misty%20bamboo%20forest%2C%20magical%20atmosphere%2C%20ancient%20Chinese%20ink%20wash%20style%2C%20soft%20ethereal%20lighting%2C%20jade%20green%20and%20white%20tones%2C%20romantic%20fantasy%20aesthetic&width=800&height=450&seq=v23-whitesnake&orientation=landscape',
    rating: 7.8,
    description: '晚唐年间，蛇妖小白刺杀国师失败后失忆，被捕蛇人阿宣所救，一段跨越种族的爱情由此展开。',
    year: 2019,
    duration: '98分钟',
    tags: ['爱情', '奇幻', '古装'],
    isHot: false,
    isNew: false,
    views: '2.9亿',
  },
  {
    id: 'v24',
    title: '向往的生活',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20rural%20courtyard%20with%20wooden%20house%20and%20vegetable%20garden%2C%20celebrities%20cooking%20and%20farming%20together%2C%20peaceful%20countryside%20atmosphere%2C%20golden%20sunlight%2C%20green%20mountains%20background%2C%20slow%20living%20vibe%2C%20warm%20natural%20documentary%20style&width=800&height=450&seq=v24-back-to-field&orientation=landscape',
    rating: 7.6,
    description: '在远离喧嚣的蘑菇屋，三五好友一起劳作、做饭、聊天，回归最简单质朴的生活。',
    year: 2024,
    duration: '90分钟/期',
    tags: ['真人秀', '田园', '美食'],
    isHot: false,
    isNew: true,
    views: '5.1亿',
  },
  {
    id: 'v25',
    title: '人生大事',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20funeral%20home%20exterior%20in%20old%20neighborhood%2C%20middle-aged%20man%20and%20little%20girl%20sitting%20on%20doorstep%2C%20warm%20sunlight%2C%20bittersweet%20atmosphere%2C%20ordinary%20Chinese%20street%20life%2C%20humanistic%20drama%20style%2C%20earthy%20realistic%20tones&width=800&height=450&seq=v25-lighting&orientation=landscape',
    rating: 7.3,
    description: '殡葬师莫三妹遇到了孤儿武小文，两个看似毫不相干的人却相互温暖，改变了彼此的人生。',
    year: 2022,
    duration: '112分钟',
    tags: ['剧情', '家庭', '治愈'],
    isHot: false,
    isNew: false,
    views: '4.5亿',
  },
  {
    id: 'v26',
    title: '一闪一闪亮星星',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20high%20school%20campus%20at%20sunset%20with%20cherry%20blossom%20trees%2C%20young%20couple%20on%20bicycle%2C%20nostalgic%20youth%20romance%20atmosphere%2C%20soft%20pink%20and%20golden%20tones%2C%20dreamy%20lighting%2C%20coming-of-age%20drama%20style&width=800&height=450&seq=v26-star&orientation=landscape',
    rating: 7.1,
    description: '林北星意外穿越回高中时代，与张万森相遇，一次次时空交错中两颗心逐渐靠近。',
    year: 2022,
    duration: '45分钟/集',
    tags: ['爱情', '穿越', '青春'],
    isHot: false,
    isNew: false,
    views: '3.6亿',
  },
  {
    id: 'v27',
    title: '风吹半夏',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%201990s%20steel%20factory%20industrial%20scene%2C%20determined%20businesswoman%20in%20power%20suit%2C%20smoke%20stacks%20and%20machinery%2C%20entrepreneurial%20spirit%20in%20reform%20era%2C%20warm%20industrial%20tones%2C%20dramatic%20period%20drama%20style%2C%20strong%20female%20lead%20aesthetic&width=800&height=450&seq=v27-wind-blows&orientation=landscape',
    rating: 8.2,
    description: '许半夏在上世纪九十年代白手起家，在钢铁行业闯出一片天地，展现女性企业家的奋斗传奇。',
    year: 2022,
    duration: '45分钟/集',
    tags: ['商战', '励志', '年代'],
    isHot: false,
    isNew: false,
    views: '4.9亿',
  },
  {
    id: 'v28',
    title: '刺杀小说家',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20action%20film%20scene%20with%20warrior%20in%20ancient%20armor%20fighting%20monster%20in%20surreal%20landscape%2C%20visual%20effects%20spectacle%2C%20parallel%20worlds%20concept%2C%20dark%20fantasy%20atmosphere%2C%20crimson%20and%20dark%20tones%2C%20imaginative%20cinematic%20style&width=800&height=450&seq=v28-assassin&orientation=landscape',
    rating: 6.6,
    description: '一个父亲为寻找失踪女儿，接下了刺杀小说家的任务。却发现小说中的奇幻世界正影响着现实。',
    year: 2021,
    duration: '130分钟',
    tags: ['奇幻', '动作', '悬疑'],
    isHot: false,
    isNew: false,
    views: '3.2亿',
  },
  {
    id: 'v29',
    title: '奇遇人间',
    category: 'duanpian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20documentary%20short%20film%20scene%20in%20bustling%20street%20market%2C%20ordinary%20people%20daily%20life%2C%20colorful%20food%20stalls%20and%20vendors%2C%20warm%20vibrant%20street%20photography%2C%20human%20connection%20stories%2C%20authentic%20Chinese%20urban%20life%2C%20candid%20cinematic%20style&width=800&height=450&seq=v29-encounters&orientation=landscape',
    rating: 8.9,
    description: '在城市的隐秘角落，记录普通人最真实动人的生活瞬间，每个人都是自己故事的主角。',
    year: 2024,
    duration: '15分钟/集',
    tags: ['纪录', '人文', '生活'],
    isHot: false,
    isNew: true,
    views: '0.6亿',
  },
  {
    id: 'v30',
    title: '莲花楼',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20drama%20scene%20with%20wandering%20swordsman%20in%20white%20robe%20near%20lotus%20pond%2C%20misty%20mountains%2C%20elegant%20traditional%20aesthetic%2C%20jade%20green%20and%20soft%20pink%20lotus%20flowers%2C%20poetic%20wuxia%20atmosphere%2C%20serene%20yet%20powerful%20visual%20style&width=800&height=450&seq=v30-lotus&orientation=landscape',
    rating: 8.4,
    description: '曾经的武林盟主李相夷化名李莲花游历江湖，在破解一桩桩奇案中揭开当年的惊天秘密。',
    year: 2023,
    duration: '45分钟/集',
    tags: ['武侠', '探案', '古装'],
    isHot: true,
    isNew: false,
    views: '6.1亿',
  },
];